/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable react/require-default-props */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
// AudioBubbleWeb.tsx
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FiPlay, FiPause } from 'react-icons/fi';
import { Spinner } from 'react-bootstrap';
import * as Tone from 'tone';

type Props = {
  id: string;
  src: string; // URL do áudio (use content.media_url)
  height?: number; // altura da bolha
  color?: string; // cor da bolha
  rate?: number; // semelhante ao VOICE_RATE do mobile
};

const VOICE_RATE = 0.88; // mesmo do mobile
const BARS = 24;

export default function AudioBubbleWeb({
  id,
  src,
  height = 56,
  color = '#075e54',
  rate = VOICE_RATE,
}: Props) {
  const playerRef = useRef<Tone.Player | null>(null);
  const pitchRef = useRef<Tone.PitchShift | null>(null);

  const [isLoading, setIsLoading] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [pos, setPos] = useState(0); // segundos
  const [dur, setDur] = useState(0); // segundos

  // controle de progresso
  const intervalRef = useRef<number | null>(null);
  const startAtRef = useRef<number>(0); // Tone.now() quando iniciou
  const offsetRef = useRef<number>(0); // segundos já avançados ao dar play

  // garantir player único: quando um começa, pausamos os outros
  useEffect(() => {
    const onSomeonePlayed = (e: Event) => {
      const detail = (e as CustomEvent<{ id: string }>).detail;
      if (detail?.id !== id && playing) {
        stopInternal(false); // pause este se outro começou
      }
    };
    window.addEventListener('audio-play-web', onSomeonePlayed as EventListener);
    return () => {
      window.removeEventListener(
        'audio-play-web',
        onSomeonePlayed as EventListener,
      );
    };
  }, [id, playing]);

  // carrega / inicializa
  useEffect(() => {
    let mounted = true;

    const init = async () => {
      try {
        setIsLoading(true);

        if (!playerRef.current) {
          const p = new Tone.Player({
            url: src,
            autostart: false,
            onload: () => {
              if (!mounted) return;
              const d = p.buffer?.duration ?? 0;
              setDur(d);
              setPos(0);
              setIsLoading(false);
            },
            onerror: () => setIsLoading(false),
          });

          const pitch = new Tone.PitchShift({
            pitch: -2,
            windowSize: 0.1,
            delayTime: 0.1,
          });

          p.connect(pitch);
          // Ajuste de "rate/anonimato": em Tone, podemos usar playbackRate
          // (não há pitch correction perfeita como no AV, mas aproxima)
          p.playbackRate = rate;

          pitch.toDestination();

          playerRef.current = p;
          pitchRef.current = pitch;
        } else {
          // se já existe e a URL mudou, recarrega
          if ((playerRef.current as any)._url !== src) {
            await playerRef.current.load(src);
            const d = playerRef.current.buffer?.duration ?? 0;
            setDur(d);
            setPos(0);
          }
          setIsLoading(false);
        }
      } catch (e) {
        setIsLoading(false);
      }
    };

    init();

    return () => {
      mounted = false;
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      playerRef.current?.stop();
      playerRef.current?.dispose();
      pitchRef.current?.dispose();
      playerRef.current = null;
      pitchRef.current = null;
    };
  }, [src, rate]);

  const startProgressLoop = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = window.setInterval(() => {
      const now = Tone.now();
      const elapsed = Math.max(0, now - startAtRef.current) + offsetRef.current;
      setPos(Math.min(elapsed, dur || elapsed));
      // terminou?
      if (dur && elapsed >= dur) {
        stopInternal(true);
      }
    }, 100);
  };

  const stopProgressLoop = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const playInternal = async () => {
    const p = playerRef.current;
    if (!p) return;

    await Tone.start();

    // se outro player começou, avisa que este é o dono agora
    window.dispatchEvent(new CustomEvent('audio-play-web', { detail: { id } }));

    // se já terminou, reseta
    if (dur && pos >= dur) {
      offsetRef.current = 0;
      setPos(0);
    }

    startAtRef.current = Tone.now();
    // play a partir do offset atual
    p.start(undefined, offsetRef.current);
    setPlaying(true);
    startProgressLoop();
  };

  const stopInternal = (toEndCheck: boolean) => {
    const p = playerRef.current;
    if (p) p.stop();

    // guarda offset (pausa) a partir do pos atual — exceto se finalizou
    if (!toEndCheck) {
      offsetRef.current = Math.min(dur || pos, pos);
    } else {
      offsetRef.current = 0;
      setPos(0);
    }

    stopProgressLoop();
    setPlaying(false);
  };

  const onToggle = async () => {
    if (isLoading) return;

    if (playing) {
      stopInternal(false);
    } else {
      await playInternal();
    }
  };

  const progress = useMemo(() => {
    if (!dur) return 0;
    return Math.min(1, Math.max(0, pos / dur));
  }, [pos, dur]);

  const format = (sec = 0) => {
    const total = Math.max(0, Math.floor(sec));
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };

  const activeBars = Math.max(1, Math.floor(progress * BARS));
  const barHeights = useMemo(() => {
    const base = [
      6, 10, 16, 12, 20, 14, 24, 18, 28, 16, 22, 12, 18, 10, 16, 20, 14, 24, 18,
      12, 16, 10, 8, 6,
    ];
    const out: number[] = [];
    for (let i = 0; i < BARS; i++) out.push(base[i % base.length]);
    return out;
  }, []);

  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={isLoading}
      style={{
        ...styles.bubble,
        backgroundColor: color,
        height,
        cursor: isLoading ? 'wait' : 'pointer',
        opacity: isLoading ? 0.7 : 1,
      }}
    >
      <div style={styles.left}>
        {isLoading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : playing ? (
          <FiPause color="#fff" size={20} />
        ) : (
          <FiPlay color="#fff" size={20} />
        )}
      </div>

      <div style={styles.waveWrap}>
        <div style={styles.waveRow as React.CSSProperties}>
          {Array.from({ length: BARS }).map((_, i) => {
            const isActive = i < activeBars;
            const h = barHeights[i];
            return (
              <div
                key={i}
                style={{
                  ...styles.bar,
                  height: isActive ? h + 8 : h,
                  opacity: isActive ? 1 : 0.6,
                }}
              />
            );
          })}
        </div>
      </div>

      <span style={styles.time}>{pos > 0 ? format(pos) : format(dur)}</span>
    </button>
  );
}

const styles = {
  bubble: {
    borderRadius: 20,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 8,
    paddingBottom: 8,
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center',
    maxWidth: '100%',
    border: 'none',
    outline: 'none',
    color: '#fff',
  },
  left: {
    width: 40,
    height: 40,
    borderRadius: 14,
    background: 'rgba(255,255,255,0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  waveWrap: { flex: 1, display: 'flex', justifyContent: 'center' },
  waveRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center',
    gap: 3,
  },
  bar: { width: 2, background: '#fff', borderRadius: 1 },
  time: {
    marginLeft: 10,
    color: '#fff',
    fontWeight: 600,
    minWidth: 46,
    textAlign: 'right' as const,
  },
};
